export const ApiRoutes = {
  appRoutes: {
    avatar: 'avatar',
    credit: 'credit',
    imageAsset: 'image_asset',
    import: 'import',
    jobCard: 'job_card',
    jobType: 'career_path',
    options: 'assessment_option',
    pleAssessment: 'assessment',
    pleAssessmentQuestion: 'assessment_question',
    pleContent: 'content',
    pleVideoAsset: 'video_asset',
    question: 'assessment_question',
    sampleFile: 'sample-file',
    skillCard: 'skill',
    successStory: 'success_story',
    upload: 'ple_upload_file',
    uploadJobs: 'ple_job_card',
  },
  plePrefix: 'ple',
  serviceUrls: {
    publicPath: 'public/api',
    version1: 'v1',
    version2: 'v2',
  },
};
